import { useParams } from "react-router";

export const useGetInvitationCompanyOneTimeParams = () => {
	const { companyID, oneTimePass } = useParams();

	return {
		companyID: companyID!,
		oneTimePassword: oneTimePass!,
	};
};
